import { render, staticRenderFns } from "./PricingSuccess.vue?vue&type=template&id=77895646&scoped=true"
import script from "./PricingSuccess.vue?vue&type=script&lang=js"
export * from "./PricingSuccess.vue?vue&type=script&lang=js"
import style0 from "./PricingSuccess.vue?vue&type=style&index=0&id=77895646&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77895646",
  null
  
)

export default component.exports